import { EntryType } from "@/types";
import { FileText, Truck, Wrench, Receipt, Camera, DollarSign, Calculator, ArrowDownToLine, ChevronsUp, ShoppingCart } from "lucide-react";
import i18n from "@/i18n/config";

export const getEntryTypes = () => [
  {
    type: "expense" as EntryType,
    label: i18n.t("entry_modal.entry_types.expense"),
    icon: DollarSign,
    color: "text-cyan-500"
  },
  // "Verilen Çek" (givenCheck) is now created via the expense flow's
  // "Çek" payment method, so it no longer appears as a standalone tile.
  {
    type: "receivedCheck" as EntryType,
    label: i18n.t("entry_modal.entry_types.received_check"), 
    icon: Calculator,
    color: "text-emerald-500" 
  },
  { 
    type: "laborCost" as EntryType, 
    label: i18n.t("entry_modal.entry_types.labor_cost"), 
    icon: Wrench,
    color: "text-purple-500"
  },
  { 
    type: "delivery" as EntryType, 
    label: i18n.t("entry_modal.entry_types.delivery"), 
    icon: Truck,
    color: "text-blue-500"
  },
  { 
    type: "sitePhoto" as EntryType, 
    label: i18n.t("entry_modal.entry_types.site_photo"), 
    icon: Camera,
    color: "text-pink-500"
  },
  { 
    type: "sale" as EntryType, 
    label: i18n.t("entry_modal.entry_types.sale"), 
    icon: ShoppingCart,
    color: "text-green-500"
  },
];

export const getEntryTypeLabel = (type: EntryType | null): string => {
  if (!type) return "";
  
  switch(type) {
    case "expense":
      return i18n.t("entry_modal.entry_types.expense");
    case "givenCheck":
      return i18n.t("entry_modal.entry_types.given_check");
    case "receivedCheck":
      return i18n.t("entry_modal.entry_types.received_check");
    case "laborCost":
      return i18n.t("entry_modal.entry_types.labor_cost");
    case "delivery":
      return i18n.t("entry_modal.entry_types.delivery");
    case "sitePhoto":
      return i18n.t("entry_modal.entry_types.site_photo");
    case "sale":
      return i18n.t("entry_modal.entry_types.sale");
    default:
      return "";
  }
};

export const getPeople = () => [
  { id: "1", name: "Ahmet Yılmaz", category: "laborer" },
  { id: "2", name: "Mehmet Demir", category: "supplier" },
  { id: "3", name: "Can İnşaat Ltd.", category: "subcontractor" },
];

export const getProjects = () => [
  { id: "1", name: "Marina Towers" },
  { id: "2", name: "Green Valley" },
];
